import {Container} from "../components/common";
import {useEffect, useState} from "react";

const loginDomain = process.env.REACT_APP_OKTA_DOMAIN;

const LinkOidcSuccessView = (idp) => {
    const [redirect, setRedirect] = useState(false)

    if(redirect) {
        window.location.replace(`https://${loginDomain}/login/signout`)
    }

    useEffect(() => {
        setTimeout(() => {
            setRedirect(true)
        }, 2000)
    }, [setRedirect])

    return (
        <Container>
            <h1>Link up Success</h1>
            <p>Now you can log on with iAM Smart, you will be redirected to the log on page.</p>
        </Container>
    )
}

export const LinkAppleSuccessView = () => LinkOidcSuccessView("Apple");
export const LinkFacebookSuccessView = () => LinkOidcSuccessView("Facebook");
export const LinkLinkedInSuccessView = () => LinkOidcSuccessView("Linkedin");
export const LinkGoogleSuccessView = () => LinkOidcSuccessView("Apple");
export const LinkIAmSmartSuccessView = () => LinkOidcSuccessView("Iamsmart");
